"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAnnualizedRewardAmount = void 0;
const constants_1 = require("./constants");
function calculateAnnualizedRewardAmount(amountPerBlock, blockTimeMs) {
    const blocksPerYear = constants_1.MS_PER_YEAR.div(blockTimeMs);
    return amountPerBlock.mul(blocksPerYear);
}
exports.calculateAnnualizedRewardAmount = calculateAnnualizedRewardAmount;
//# sourceMappingURL=rewards.js.map